import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useDeleteHiringStage } from 'modules/ats/hooks/hiringStages/useDeleteHiringStage'
import { HiringStage } from 'modules/ats/hooks/hiringStages/useHiringStages'

interface Props {
  onClose: () => void
  currentStage: HiringStage
}

export const DeleteStageModal = ({ onClose, currentStage }: Props) => {
  const { deleteAtsHiringStage, loading } = useDeleteHiringStage()

  const onDelete = async () => {
    const result = await deleteAtsHiringStage({
      id: currentStage.id,
    })

    const handled = handleResult(result, (_errors) => undefined)

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.removed_successfully'),
      })
      onClose()
    }
  }

  return (
    <Modal
      title={i18n.t('ats.hiring_pipelines.settings.sidepanel.delete_stage_modal.title')}
      description={i18n.t('ats.hiring_pipelines.settings.sidepanel.delete_stage_modal.description')}
      illustration="delete"
      onClose={onClose}
      onSubmit={onDelete}
      footer={
        <Box flexDirection="row" gap="s16">
          <Button type="secondary" onClick={() => onClose()}>
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={loading} type="negative" submit>
            {i18n.t('common.delete')}
          </Button>
        </Box>
      }
    />
  )
}
